import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { metabolic } from "../../../../constants";


export default function MetabolicCard() {
  

return (

    <CardImageMarkers 
    
        image={metabolic}
        title="METABOLIC HEALTH"
        subtitle="Control your energy and body"
        markersTitle=""
        markers="LDL, HDL, 
                Total Cholesterol, 
                Tryglycerides,
                ApoB, HbA1c, Glucose, 
                Creatine Kinase, LDH
"

    />


)
}